import HttpStatusCodes from '@/constants/api/HttpStatusCodes'
// eslint-disable-next-line no-unused-vars
import TimeEntryAPIErrorContext from '@/constants/booking/timeEntries/TimeEntryAPIErrorContext'
// eslint-disable-next-line no-unused-vars
import ResultDTO from '@/models/app/resultDTO'

/**
 * Handles API error responses and provides structured feedback.
 */
export class TimeEntryErrorModel {
  /**
   * @param {ResultDTO} errorResponse - The error response from the API
   * @param {keyof TimeEntryAPIErrorContext} context - The context (API endpoint) the error was received from.
   */
  constructor(errorResponse, context) {
    /**
     * HTTP response code
     * @type {number}
     * @example 409
     */
    this.httpResponseStatus = errorResponse.statusCode
    /**
     * @type {string}
     */
    this.errorCode = errorResponse.error?.code || 'unknown_error'
    /**
     * @type {string}
     */
    this.errorMessageTranslationKey = `bookings.timeEntries.${context}.api.errors.${this.errorCode}`
    /**
     * @type {string}
     */
    this.param = errorResponse.error?.param || null
    /**
     * @type {keyof TimeEntryAPIErrorContext}
     */
    this.context = context
  }

  /**
   * Determines if the feature should be disabled due to revoked access.
   * @returns {boolean}
   */
  isFeatureAccessRevoked() {
    return this.errorCode === 'feature_not_enabled'
  }

  /**
   * Determines if the app state should be refreshed.
   * @returns {boolean}
   */
  shouldTriggerTimeEntryStatusRefresh() {
    return [
      HttpStatusCodes.Conflict,
      HttpStatusCodes.NotFound,
      HttpStatusCodes.Forbidden,
    ].includes(this.httpResponseStatus)
  }

  /**
   * Determines if the request is eligible for a retry.
   * @returns {boolean}
   */
  isRetryAllowed() {
    return (
      !this.isFeatureAccessRevoked() &&
      !this.shouldTriggerTimeEntryStatusRefresh()
    )
  }
}
